// ============================================================
// BrandMark — 天水豆腐 品牌標誌元件
// ------------------------------------------------------------
// 依《天水豆腐-視覺識別規範手冊》(CIS)：
//   - 正式標誌為「流雲水波」Symbol，禁用已廢棄的「水波方印」
//   - 禁止反轉、拉長壓縮、加漸層、加外框、加陰影效果
//   - 需保留淨空區（四周至少 Symbol 高度的 0.8–1 倍）
//   - Symbol 單獨使用最小 4mm ≈ 15px；Lockup02 直式最小 ≈ 38px
//
// 因此本元件只做「等比縮放」與「留白」，不對標誌本身加任何效果。
// ============================================================

interface Props {
  /** symbol = 只有流雲水波圖形；lockup = 直式完整組合（天水豆腐 + TIAN SHUI + 印 + Symbol） */
  variant?: 'symbol' | 'lockup';
  /** 標誌顏色版本。CIS 允許：白底黑標、藍底白標、黑底白標 */
  tone?: 'black' | 'white';
  /** 高度（px）。Symbol 不低於 16、Lockup 不低於 40，低於此改用更簡單的組合 */
  height?: number;
  className?: string;
}

export function BrandMark({ variant = 'symbol', tone = 'black', height, className = '' }: Props) {
  const src = `/brand/${variant === 'lockup' ? 'lockup-vertical' : 'symbol'}-${tone}.png`;
  const h = height ?? (variant === 'lockup' ? 96 : 28);
  const min = variant === 'lockup' ? 40 : 16;

  return (
    <img
      src={src}
      alt="天水豆腐"
      // 淨空區以 padding 保留，符合 CIS 對周圍不得有其他元素的要求
      style={{ height: Math.max(h, min), width: 'auto' }}
      className={`select-none pointer-events-none ${className}`}
      draggable={false}
    />
  );
}
